import React from "react";
import dollars from "../../dollar-format";
import {percent} from "../../utils";
import {stringISOtoUS} from "../../date-converter";

export default ({columns, rows, hasTotalRow, className}) => {
    let keys = Array.isArray(rows) ? {...rows} : rows;
    keys = Object.keys(keys);

    const formatTableValue = (value, type, withCents) => {
        if (value === null || value === '') return;
        switch (type) {
            case '$':
                return dollars(value, withCents);
            case '%':
                return percent(value);
            case 'date':
                return stringISOtoUS(value);
            default:
                return value;
        }
    };

    if (!keys.length)
        return <div className='PipelineTable_no_results'>No results found</div>;

    return (
        <table className={`PipelineTable ${className ? className : ''}`}>
            <thead>
            <tr>
                {
                    columns.map((column, index) => <th key={index} className="PipelineTable_th">{column.name}</th>)
                }
            </tr>
            </thead>
            <tbody>
            {
                keys.map((key, index) => (
                    <tr key={key}>
                        {
                            columns.map((column, colIndex) => {
                                return (
                                <td key={key + '-' + colIndex}
                                    className={`${column.class ? column.class : 'PipelineTable_td'} ${hasTotalRow && index === keys.length - 2 ? 'border-bottom' : ''}`}>
                                    {formatTableValue(rows[key][column.key], column.format, column.withCents)}
                                </td>
                                )
                            })
                        }
                    </tr>
                ))
            }
            </tbody>
        </table>
    );
}